import { PlannerStates } from '../models/Planner/plannerStates.js';
import winston from 'winston';
import { AppEnv } from './AppConfig.js';

export function getValidString<T>(obj: T, key: keyof T): string | null {
  const value = obj[key];

  if (!value || typeof value !== 'string') {
    return null;
  }

  return value;
}

export function isValidString(value: string): boolean {
  return value && typeof value === 'string' && value.trim() !== '';
}

export function isProd(env: string): boolean {
  return env === 'prod';
}

export function isProdTabActive(env: 'production' | 'cte') {
  return env === 'production';
}

export function isProdFromState(state: PlannerStates): boolean {
  const prodStates = [
    PlannerStates.BACKUP,
    PlannerStates.CHINA_CONFIG,
    PlannerStates.CONFIG,
    PlannerStates.STAGING,
  ];
  return prodStates.includes(state);
}

const DEV_PROJECT_ID = 'ingka-pnv-planners-dev';
export function getGcpProjectId(logger?: winston.Logger): string {
  const envProject = AppEnv.get().projectId;
  if (envProject) {
    logger?.info('GCP Project set via environment variable');
    return envProject;
  }
  logger?.info('GCP Project not set in environment, defaulting to dev project');
  return DEV_PROJECT_ID;
}

// TODO: We should just pass in dev/prod directly via env vars... this is silly.
export function isGcpDevProject(): boolean {
  return !isGcpProdProject();
}

function isGcpProdProject(): boolean {
  return getGcpProjectId() === 'ingka-pnv-planners-prod';
}
